import { GetterTree } from 'vuex';
import { IGamesState } from './types';
import { IRootState } from '../types';
import _countBy from 'lodash.countby';
import _flatten from 'lodash.flatten';

export const getters: GetterTree<IGamesState, IRootState> = {
  getCraftedItemByRoute: (state: IGamesState) => ({
    gameRoute,
    itemName,
  }: {
    gameRoute: string;
    itemName: string;
  }) => {
    const currentGame = state.games.find(game => game.route === gameRoute);
    if (currentGame && currentGame.craftedItems) {
      const craftedItem = currentGame.craftedItems.find(
        item => item.name === itemName,
      );
      if (craftedItem) {
        return craftedItem;
      }
    }
    return null;
  },
  gamesUsingGalaChain(state: IGamesState) {
    return state.games
      .filter(game => game.usesGalaChain && game.showGamePage)
      .map(gameObj => gameObj.collection);
  },
};
